import { SharedPageOverlayProps } from '../../types/SharedPageOverlayProps';
import { SharedPanelProps } from '../../types/SharedPanelProps';
import { SharedStepperProps } from '../../types/SharedStepperProps';
import { UserAction } from '../../types/UserAction';
import { Footer } from '../Footer/Footer';
import { Header } from '../Header/Header';
import { PageOverlay } from '../PageOverlay/PageOverlay';

export interface Props extends SharedPageOverlayProps {
  /** Main actions, other than cancel, displayed in the footer */
  actions: UserAction[];
  /** Action to close the overlay */
  cancelAction: UserAction;
  /** Contents */
  children: React.ReactNode;
  /** Title, will be replaced by stepper (if provided). */
  title: string;
  /** Optional back action */
  backAction?: UserAction;
  /** Optional callout content in the header */
  headerCalloutContent?: React.ReactNode;
  /** Optional action buttons to show in the footer on the left */
  leftActions?: UserAction[];
  /** Optional panel */
  panel?: SharedPanelProps;
  /** Stepper contents */
  stepper?: SharedStepperProps;
}

export const FullPageOverlay = ({
  actions,
  backAction: overrideBackAction,
  backgroundGradient,
  cancelAction,
  children,
  enableContentPadding,
  headerCalloutContent,
  leftActions: overrideLeftActions,
  loadingContent,
  panel,
  stepper,
  title,
}: Props) => {
  const header = (
    <Header
      calloutContent={headerCalloutContent}
      size="l"
      stepper={stepper}
      title={title}
    />
  );

  // ensures certain properties of backAction cannot be configured
  const backAction = overrideBackAction
    ? [
        {
          ...overrideBackAction,
          icon: undefined,
          level: 'tertiary' as const,
        },
      ]
    : [];

  // Combine backAction and leftActions
  const leftActions = [...(backAction ?? []), ...(overrideLeftActions ?? [])];

  const footer = (
    <Footer actions={[cancelAction, ...actions]} leftActions={leftActions} />
  );

  return (
    <PageOverlay
      isFullPage
      isVisible
      backgroundGradient={backgroundGradient}
      disableHideOnEscape={true}
      enableContentPadding={enableContentPadding}
      header={header}
      footer={footer}
      loadingContent={loadingContent}
      panel={panel}
    >
      {children}
    </PageOverlay>
  );
};
